export default __webpack_public_path__ + "static/media/025-teapot.9fdc2947.svg";